import { Card, CardHeader, Stack, Typography } from '@mui/material'
import { EquipmentDto } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { Tile, useMinimalsTheme } from '@tom-ui/ui'
import { EquipmentStatusChip } from '../statusChip/EquipmentStatus'

interface Props {
  equipment: EquipmentDto
  onClick?: (equipment: EquipmentDto) => void
}
export const Equipment = ({ equipment, onClick }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const handleClick = () => {
    if (onClick) {
      onClick(equipment)
    }
  }

  return (
    <Card onClick={handleClick} sx={{ cursor: onClick ? 'pointer' : undefined }}>
      <CardHeader
        title={
          <Stack flexDirection='row' justifyContent='space-between'>
            <Typography variant='h4'>{equipment.name}</Typography>
            <EquipmentStatusChip
              operationalStatus={equipment.operationalStatus}
              isOwned={equipment.isOwned}
              isInactive={!equipment.isActive}
              isInOperation={false}
            />
          </Stack>
        }
        subheader={
          <Stack paddingTop={theme.customSpacing.xs}>
            <Typography variant='body2'>{t(equipment.equipmentType)}</Typography>
          </Stack>
        }
        sx={{ paddingBottom: theme.customSpacing.m }}
      />
      {(!!equipment.maxStackingHeight || !!equipment.maxLiftWeight) && (
        <Stack
          flexDirection='row'
          sx={{
            backgroundColor: theme.palette.grey[100],
            gap: theme.customSpacing.xl,
            padding: theme.customSpacing.m,
          }}
        >
          {!!equipment.maxLiftWeight && (
            <Tile
              label={t('maxLiftWeight', 'Max lift weight')}
              value={equipment.maxLiftWeight + ' kg'}
            />
          )}
          {!!equipment.maxStackingHeight && (
            <Tile
              label={t('maxStackingHeight', 'Max stacking height')}
              value={equipment.maxStackingHeight}
            />
          )}
        </Stack>
      )}
    </Card>
  )
}
